<template>
  <section class="sub_contents_wrap container">
    <div class="brick_box">
      <div class="view_top">
        <div class="view_title">{{ qna.title }}</div>
        <ul class="view_info">
          <li class="view_user">{{ qna.firstRegrName }}</li>
          <li class="view_date">{{ qna.firstRegDatetime }}</li>
        </ul>
        <div class="view_file" v-if="files.length > 0 && files != null">
          <ul>
            <li>
              <span>File</span>
              <a
                v-for="(file, index) in files"
                :key="index"
                href="#"
                @click="downloadFile(file)"
              >
                {{ file.fileNm }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="qna.content" v-html="qna.content" class="view_t"></div>

      <!-- 답변 시작 -->
      <div class="view_answer_box" v-if="qna.answerTitle != null">
        <div class="va_top">
          <p>
            <strong>{{ qna.answerTitle }}</strong>
          </p>
          <span>{{ qna.answerRegrDatetime }}</span>
        </div>
        <div v-if="qna.answerContent" v-html="qna.answerContent" class="va_text"></div>
      </div>
      <!-- 답변 끝 -->
      <div class="list_bottom_bt">
        <router-link to="/mylibrary/myqna" class="btn btn-outline-dark btn-lg m-1"
          >List</router-link
        >
        <a
          v-if="
            qna.answerTitle == null && qna.firstRegrId == this.$session.get('loginUser')
          "
          @click="deleteQna"
          class="btn btn-secondary btn-lg m-1"
          >{{ $t("common.delete") }}</a
        >
        <router-link
          v-if="
            qna.answerTitle == null && qna.firstRegrId == this.$session.get('loginUser')
          "
          :to="{ name: 'myqnaForm', params: { boardId: qna.boardId } }"
          class="btn btn-primary btn-lg m-1"
          >{{ $t("common.edit") }}</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
import { goDownloadFile } from "@/api/file";
import { getQna, deleteQna } from "@/api/qna";

export default {
  data() {
    return {
      id: "",
      qna: {
        title: "",
        content: "",
        attributeName: "",
        firstRegDatetime: "",
      },
      files: [],
      confirmYn: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      // qna list 불러오기 검색시 동일
      try {
        this.boardId = this.$route.query.boardId;
        const response = await getQna(this.boardId);
        this.qna = response.data.qna;
        this.files = response.data.files;
      } catch (err) {
        console.log(err);
      }
    },
    async downloadFile(file) {
      try {
        const res = await goDownloadFile(file.fileId);
        let data = res.data;
        if (!data) {
          return;
        }
        const blob = new Blob([data]);
        if (window.navigator.msSaveOrOpenBlob) {
          // compatible IE10
          navigator.msSaveBlob(blob, file.fileId);
        } else {
          // IE core support other non-H5 browsers
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", file.fileNm);
          document.body.appendChild(link);
          link.click();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async deleteQna() {
      this.confirmYn = confirm(this.$t("alert.delete"));
      if (this.confirmYn) {
        try {
          this.qna.boardId = this.boardId;
          this.qna.fileList = this.files;
          const { data } = await deleteQna(this.qna);
          console.log(data);
          if (data.status) {
            this.$router.push({ name: "myqnaList" });
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
  },
};
</script>

<style></style>
